import { z } from 'zod';
import { validateDomain } from '@terra/shared-utils';

export const CompanyDomainSchema = z
  .string()
  .trim()
  .transform((value, ctx) => {
    const result = validateDomain(value);

    if (!result.ok) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: result.message,
      });

      return z.NEVER;
    }

    return result.value;
  });

export const optionalCompanyDomainSchema = z.preprocess(
  (value) =>
    typeof value === 'string' && value.trim() === '' ? undefined : value,
  CompanyDomainSchema.optional(),
);
